<nz-modal [nzVisible]="isVisible" [nzStyle]="styleObject" [nzFooter]='null'
  [nzBodyStyle]="{height:'400px', 'background-color': 'rgb(0 0 0 / 30%)'}" [nzClosable]="true"
  (nzOnCancel)="handleCancel()">

  <form nz-form [formGroup]='frmRegister' (ngSubmit)='onclick(frmRegister.value)' class='form' *nzModalContent>

    <h1 *ngIf="isAddMode" class='title'>Add User</h1>
    <h1 *ngIf="!isAddMode" class='title'>Edit User</h1>
    <nz-form-item class='formitem1'>
      <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="name">Company Name</nz-form-label>
      <nz-form-control>
        <input nz-input name='name' type="text" formControlName='name' />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class='features'>
      <label>features </label>
    </nz-form-item>
    <nz-form-item class='formitem1'>
      <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="solar">solar</nz-form-label>
      <nz-form-control>
        <nz-select nzMode="multiple" [nzSize]="size" nzPlaceHolder="Please select" formControlName='solar'>
          <nz-option *ngFor='let list of list' [nzLabel]="features['solar'][list]" [nzValue]="list"></nz-option>
        </nz-select>

      </nz-form-control>
    </nz-form-item>
    <nz-form-item class='formitem1'>
      <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="wind">wind</nz-form-label>
      <nz-form-control>
        <nz-select nzMode="tags" [nzSize]="size" nzPlaceHolder="Please select" formControlName='wind'>
          <nz-option *ngFor='let list of list' [nzLabel]="features['wind'][list]" [nzValue]="list"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <button nz-button nzType="primary" class='button'> <span> {{ isAddMode? 'Add': 'Update'}}</span></button>
    <button nz-button nzType="primary" class='button1' (click)='handleCancel()'>Cancel</button>
  </form>


</nz-modal>